<div class="w100" fxLayout="column" fxLayoutAlign="start stretch">
  <ng-container *ngIf="!menuVisible">
    <!-- <button mat-fab color="primary" class="botMenuProd" (click)="abreMenu.emit(true)">
      <mat-icon>list</mat-icon>
    </button> -->
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row">
        <button mat-mini-fab color="primary" class="mr-10" (click)="abreMenu.emit(true)">
          <mat-icon>list</mat-icon>
        </button>
        <p *ngIf="!productoActual"><em>Elegir un producto</em></p>
        <p *ngIf="productoActual"><em>Ver otro producto</em></p>
      </div>
      <div fxLayout="row" *ngIf="!detallesVisible">
        <p><em>Detalles del producto</em></p>
        <button mat-mini-fab color="primary" class="ml-10" (click)="abreDetalles.emit(true)">
          <mat-icon>info</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <!-- <ng-container *ngIf="!productoActual; else infoProducto">
    <div fxLayout="column" fxLayoutAlign="start center">
      <h1>Estado de encuesta por producto</h1>
      <h3>En el menú de la izquierda en esta pantalla se muestra la lista de productos adquiridos por esta empresa. Para ver el estado de la encuesta perteneciente a cada producto, haga clic en una categoría de producto y posteriormente elija un año. Tras esto, se mostrarán los detalles de la encuesta seleccionada, sólo en caso de que el producto seleccionado ya cuente con una encuesta inicializada.</h3>
    </div>
  </ng-container>
  <ng-template #infoProducto>
    <ng-container *ngIf="productoActual.idSurvey == undefined && productoActual.idProducto != 43">
      <div class="mat-elevation-z4 pr-20 pl-20 m-20" fxLayout="row" fxLayoutAlign="center center">
        <h2>Este producto aún no tiene una encuesta creada</h2>
        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
      </div>
    </ng-container>
    <ng-container *ngIf="productoActual.idSurvey != undefined">
      <ng-template #encuestaOk>
        <mat-card class="example-card mat-elevation-z4 m-20" *ngIf="detallesVisible">
          <mat-card-content> -->
           <graficaemail></graficaemail>
          <!-- </mat-card-content>
        </mat-card>
      </ng-template>
    </ng-container>
  </ng-template> -->
</div>
